export default function SubtitleRule(props) {
    return (
        <div className="flex flex-row items-center justify-center w-[90%]">
            <h2 className="w-[150px] text-center">{props.text}</h2>
            <div className="w-full h-1 ml-2 bg-stone-900"/>
        </div>
    );
}